import { Component, OnInit, TemplateRef, OnDestroy, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { TranslationKeys } from 'ph-bhp-localization';
import { AppConfig } from 'src/app/app.config';
import { UserData } from 'src/app/Authorization/Models/Models';
import { PHBHPFeaturePackageConfigurationService } from '../ph-bhp-feature-package-configuration.service';
import { CountrySettings } from '../Models/CountrySettings';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-ph-bhp-configure-country',
  templateUrl: './ph-bhp-configure-country-settings.component.html',
  styleUrls: ['./ph-bhp-configure-country-settings.component.css']
})

export class PhBhpConfigureCountrySettingsComponent implements OnInit, OnDestroy {

  settingsFormGroup = new UntypedFormGroup({
    professionalSubcategoriesEnabled: new UntypedFormControl(false),
    handWashingEnabled: new UntypedFormControl(false),
    asepticTasksEnabled: new UntypedFormControl(false),
    noSterilityButtonEnabled: new UntypedFormControl(false),
    isHandwashCompliance: new UntypedFormControl(false),
    isHandwashHandrubCompliance: new UntypedFormControl(false)
  });

  @ViewChild('template') template: TemplateRef<any>;

  translationKeys: typeof TranslationKeys = TranslationKeys;
  userData: UserData;
  countryId: number;

  constructor(private service: PHBHPFeaturePackageConfigurationService, private layoutService: PHBHPLayoutPackageService, private modalService: BsModalService, public config: AppConfig) { }

  ngOnInit() {
    this.userData = this.config.userData;
    this.countryId = parseInt(this.userData.country);
    this.layoutService.showLoader = true;
    this.service.getDefaultCountrySettings(this.countryId).subscribe((countrySettings: CountrySettings) => {
      this.settingsFormGroup.setValue({
        handWashingEnabled: countrySettings.handWashingEnabled,
        professionalSubcategoriesEnabled: countrySettings.professionalSubcategoriesEnabled,
        asepticTasksEnabled: countrySettings.asepticTasksEnabled,
        noSterilityButtonEnabled: countrySettings.noSterilityButtonEnabled,
        isHandwashCompliance: countrySettings.isHandwashCompliance,
        isHandwashHandrubCompliance: countrySettings.isHandwashHandrubCompliance
      });
    }, (error) => {
      this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.UNKNOWN'));
    }, () => {
      this.layoutService.showLoader = false;
    });
  }

  ngOnDestroy() { }

  saveSettings() {
    var countrySettings: CountrySettings = {
      countryId: this.countryId,
      handWashingEnabled: this.settingsFormGroup.get('handWashingEnabled').value,
      professionalSubcategoriesEnabled: this.settingsFormGroup.get('professionalSubcategoriesEnabled').value,
      asepticTasksEnabled: this.settingsFormGroup.get('asepticTasksEnabled').value,
      noSterilityButtonEnabled: this.settingsFormGroup.get('noSterilityButtonEnabled').value,
      isHandwashCompliance: this.settingsFormGroup.get('isHandwashCompliance').value,
      isHandwashHandrubCompliance: this.settingsFormGroup.get('isHandwashHandrubCompliance').value,
    };

    this.layoutService.showLoader = true;
    this.service.saveDefaultCountrySettings(countrySettings.countryId, countrySettings).subscribe((countrySettingsResult) => {
      this.settingsFormGroup.setValue({
        handWashingEnabled: countrySettingsResult.handWashingEnabled,
        professionalSubcategoriesEnabled: countrySettingsResult.professionalSubcategoriesEnabled,
        asepticTasksEnabled: countrySettingsResult.asepticTasksEnabled,
        noSterilityButtonEnabled: countrySettingsResult.noSterilityButtonEnabled,
        isHandwashCompliance: countrySettingsResult.isHandwashCompliance,
        isHandwashHandrubCompliance: countrySettingsResult.isHandwashHandrubCompliance
      });
      
      this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.CONFIG_DETAILS'));
      if (countrySettingsResult.updateCountryCompliance) {
        var updateCountryComplianceData = {
          userId: this.userData.userId,
          countryId: countrySettingsResult.countryID,
          isHandwashCompliance: countrySettingsResult.isHandwashCompliance,
          isHandwashHandrubCompliance: countrySettingsResult.isHandwashHandrubCompliance
        }

        this.layoutService.showLoader = true;
        this.service.updateCountryCompliance(updateCountryComplianceData).subscribe((result) => {
          this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.COUNTRY_COMPLIANCE'));
          this.layoutService.showLoader = false;
        }, (error) => { 
        this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.UNKNOWN'));
          this.layoutService.showLoader = false; 
        this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.UNKNOWN'));
      });
      } else {
        this.layoutService.showLoader = false;
      }
    }, (error) => {
        this.layoutService.showLoader = false;
        this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.UNKNOWN'));
    });
  }
}
